import firebase from "firebase";
import flash from "../../../functions/flash";

const rejectNotarize = async (userRef, reason, setOpen) => {
  try {
    let ref = firebase.database().ref("notarize").child(userRef);
    await ref.update({
      status: "COMPLETE",
      result: "DOES NOT MEET REQUIREMENTS",
      reason,
    });
    setOpen(false);
    flash(`Notarize Verification has been updated successfully`, "success");
  } catch (e) {
    flash(e.message, "danger");
  }
};

export default rejectNotarize;
